/* eslint-disable */
/// This file is auto generated - do not edit manually
export * as Savings from './trans-website-matasplus-savings';
export * as Calculator from './trans-website-matasplus-calculator';
export * as Unboxing from './trans-website-matasplus-unboxing';
export * as PowerstepRecommendations from './trans-website-matasplus-powersteprecommendations';
export * as Advantage from './trans-website-matasplus-advantage';
export * as ChangeSubscription from './trans-website-matasplus-changesubscription';
export * as OfferNudge from './trans-website-matasplus-offernudge';

export const DeliveryBenefitsForPlus = 'Website.MatasPlus.DeliveryBenefitsForPlus';
export const PendingCancellationConfirmButton = 'Website.MatasPlus.PendingCancellationConfirmButton';
export const PendingCancellationCancelButton = 'Website.MatasPlus.PendingCancellationCancelButton';
export const ChangeToYearlySubscription = 'Website.MatasPlus.ChangeToYearlySubscription';
export const ChangeToMonthlySubscription = 'Website.MatasPlus.ChangeToMonthlySubscription';
export const SubscriptionHeadline = 'Website.MatasPlus.SubscriptionHeadline';
